import React from 'react';
import classnames from 'classnames';
import styles from './AddPhone.module.scss';

import ModalBase from '../ModalBase/ModalBase';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { BaseModalProps } from '../ModalBase/ModalBase';

interface VerifyPhoneSuccessModalProps {
  baseModalProps: BaseModalProps;
  onSuccess?: () => void;
  orgId?: string;
}

function VerifyPhoneSuccessModal({ baseModalProps, onSuccess, orgId }: VerifyPhoneSuccessModalProps) {
  return (
    <ModalBase
      baseModalProps={baseModalProps}
      contentClassName="basic"
      hideBackButton
    >
      <div className={classnames(styles.AddPhone, 'component')}>
        <h2 className="modalTitle">Phone Number Added!</h2>

        <img
          src="/img/illustrations/phoneVerified.svg"
          alt="Phone verification illustration"
        />

        <div>
          {`You successfully connected your phone number to your ${
            orgId ? 'organization' : 'Bounce account'
          }.`}
        </div>

        <Button type={ButtonType.Primary} onClick={onSuccess}>
          Start Bouncing
        </Button>
      </div>
    </ModalBase>
  );
}

export default VerifyPhoneSuccessModal;
